import { render } from "./InvoiceDetailView.vue?vue&type=template&id=6fafb6ce"
import script from "./InvoiceDetailView.vue?vue&type=script&lang=js"
export * from "./InvoiceDetailView.vue?vue&type=script&lang=js"

import "./InvoiceDetailView.vue?vue&type=style&index=0&id=6fafb6ce&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__